export type LookupDefinition = {
  entity: string;
  title: string;
  lookupUrl: string;
  createModule?: string;
};

export const lookupRegistry: Record<string, LookupDefinition> = {
  party: { entity: "party", title: "Select Party", lookupUrl: "/parties", createModule: "party-composite" },
  entryCategory: { entity: "entryCategory", title: "Select Entry Category", lookupUrl: "/ledgers/entry-categories", createModule: "entry-category" },
  shortRemark: { entity: "shortRemark", title: "Select Short Remark", lookupUrl: "/short-remarks", createModule: "short-remarks" },
  bank: { entity: "bank", title: "Select Bank", lookupUrl: "/banks", createModule: "bank" },
  bankAccount: { entity: "bankAccount", title: "Select Bank Account", lookupUrl: "/banks/accounts?bankId={bankId}", createModule: "bank-account" },
  accountLedger: { entity: "accountLedger", title: "Select Ledger", lookupUrl: "/ledgers/all", createModule: "account-ledger" },
  childLedger: { entity: "childLedger", title: "Select Under Ledger", lookupUrl: "/ledgers/children?parentId={parentLedgerId}", createModule: "account-ledger" },
  sacTaxProfile: { entity: "sacTaxProfile", title: "Select HSN / SAC", lookupUrl: "/sac-tax-profile/lookup", createModule: "sac-tax-profile" },
  billUnitDefinition: { entity: "billUnitDefinition", title: "Select Unit", lookupUrl: "/bill-unit-definitions/lookup", createModule: "bill-unit-definition" },
  accountGroup: { entity: "accountGroup", title: "Select Account Group", lookupUrl: "/ledgers/parent-candidates", createModule: "account-group" }
};
